<template>
    <div class="program-detail-card mb-4">
        <p class="cards-title">applications</p>
        <div v-if="applications.length" class="flex flex-col items-start justify-evenly p-3 py-3">
            <p v-for="application in applications" :key="application.id" class="programs-tags">
               {{ application.name }}
            </p>
        </div>
        <div v-else class="empty-box add"></div>
    </div>
</template>
<script setup lang="ts">
import { ApplicationTypesInterface } from '@/models/programVersionsInterface';
import { defineProps } from 'vue';

defineProps<{
    applications?: ApplicationTypesInterface[]
}>()
</script>
<style lang="scss" scoped>
.application-box {
    border-left: $border;
    margin: 1.5rem 0 2rem 1.5rem;
    padding-left: 1.2rem;
    padding-top: 1.2rem;

    .application {
        padding-bottom: 1.5rem;
        color: $font-color;
        font-size: 1rem;
        font-weight: 500;
        position: relative;

        &::before {
            content: "";
            display: inline-block;
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background-color: $blue-light;
            border: 4px solid #eee;
            position: absolute;
            left: -30px;
            top: 10px;
        }

        .class-name {
            color: $font-color-super-light;
            font-size: 0.9rem;
            text-transform: uppercase;
            font-weight: 300;

        }
    }
}
</style>
